/**
 * FMS 讀取範圍（be doc 261019 FMS_READ_SCOPE_ROUTE_SEPARATION_HANDOFF）：
 * - `all`：原路由，需 `.read`，財務管理用
 * - `self`：`/self` 路由，需 `.self`，個人中心用；只回登入者建立的資料
 */
export const FMS_READ_SCOPE = Object.freeze({ ALL: 'all', SELF: 'self' });

export function fmsReadBasePath(resource, scope = FMS_READ_SCOPE.ALL) {
  return scope === FMS_READ_SCOPE.SELF ? `/fms/${resource}/self` : `/fms/${resource}`;
}
